<div class="u-row u-row--sm">
	<tvcore-rich-text-editor
		[control]="control"
		[description]="description"
		[showErrors]="showErrors && requiredError"
		[title]="title"
		class="u-col-xs-10"
		placeholder="Toelichting"
	>
		<p *ngIf="showErrors && requiredError"
			 class="u-text--sm u-text--error u-m-top--xxs">
			Toelichting is verplicht.
		</p>
	</tvcore-rich-text-editor>
</div>

